import { render, staticRenderFns } from "./ConfigSelector.vue?vue&type=template&id=a3c59cc0&"
import script from "./ConfigSelector.vue?vue&type=script&lang=ts&"
export * from "./ConfigSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports